var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-button-file-icon",class:{
    'wp-button-file-icon_disabled': _vm.disabled,
    'wp-button-file-icon_xls': _vm.xls,
  },on:{"click":_vm.onClick}},[_c('div',{staticClass:"wp-button-file-icon__text"},[_vm._t("default")],2),(_vm.icon)?_c('div',{staticClass:"wp-button-file-icon__icon"},[_c('VIcon',{attrs:{"size":"26"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }